import React, { useContext } from "react";
import floorImg1 from "@images/services/podlogi-drewniane-main.webp";
import floorImg2 from "@images/services/podlogi-1.webp";
import floorImg3 from "@images/services/podlogi-2.webp";
import { LanguageContext } from '../../../index';

const FloorsServiceContent = ({ sTitle }) => {
    const { language } = useContext(LanguageContext);

    if (language === "en") {
        return (
            <div className="service-single-wrap">
                <div className="service-single-item">
                    <div className="service-single-main-img">
                        <img src={floorImg1} alt={sTitle} />
                    </div>
                    <div className="service-single-title">
                        <h3>{sTitle}</h3>
                    </div>
                    <p>
                        Wooden floors are synonymous with natural beauty, durability, and timeless elegance. Wood, as a flooring material, works perfectly in both classic and modern interiors, giving them a warm and cozy character. By choosing wooden floors, you invest in comfort, high quality, and unique style.
                    </p>
                    <p>
                        Oak floors are the most popular, distinguished by exceptional abrasion resistance, stability, and beautiful natural grain. Oak floorboards are an excellent choice for those who value durability and aesthetics. Oak wood works great in living rooms, bedrooms, and commercial spaces, providing not only visual appeal but also acoustic and thermal comfort.
                    </p>
                    <p>
                        Properly maintained wooden floors can last for many years, retaining their unique appearance. Thanks to a wide range of finishes and colors, wooden floors can be perfectly matched to any interior design style. In the Małopolska region, especially in Kraków, wooden floors are the number one choice for those seeking durable and aesthetic solutions for their home or office.
                    </p>
                    <div className="row mt-4">
                        <div className="col-md-6 col-sm-6 col-12">
                            <div className="p-details-img">
                                <img src={floorImg2} alt={sTitle + " - photo 1"} />
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-6 col-12">
                            <div className="p-details-img">
                                <img src={floorImg3} alt={sTitle + " - photo 2"} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="service-single-item list-widget">
                    <div className="service-single-title">
                        <h3>Advantages of wooden floors</h3>
                    </div>
                    <ul>
                        <li>Natural, unique appearance and warmth in every interior</li>
                        <li>High durability and resistance to mechanical damage</li>
                        <li>Possibility of multiple renovations and sanding</li>
                        <li>Improved acoustics and thermal insulation of rooms</li>
                        <li>Ecological and healthy solution for the home</li>
                    </ul>
                </div>
                <div className="service-single-item">
                    <div className="service-single-title">
                        <h3>Why choose wooden floors?</h3>
                    </div>
                    <p>
                        Wooden floors are a long-term investment. Thanks to their versatility and timeless character, wood never goes out of style. It is allergy-friendly, easy to keep clean, and perfectly matches various interior styles. By choosing wooden floors, you emphasize the prestige and uniqueness of your home or office.
                    </p>
                </div>
                <div className="service-single-item list-widget">
                    <div className="service-single-title">
                        <h3>Wooden floor installation process</h3>
                    </div>
                    <ul>
                        <li>Advice on choosing the right wood species and finish</li>
                        <li>Professional measurement and substrate preparation</li>
                        <li>Installation by experienced professionals</li>
                        <li>Finishing and surface protection</li>
                        <li>Instructions on floor care and maintenance</li>
                    </ul>
                </div>
            </div>
        );
    }

    // Polish version (original)
    return (
        <div className="service-single-wrap">
            <div className="service-single-item">
                <div className="service-single-main-img">
                    <img src={floorImg1} alt={sTitle} />
                </div>
                <div className="service-single-title">
                    <h3>{sTitle}</h3>
                </div>
                <p>
                    Podłogi drewniane to synonim naturalnego piękna, trwałości i ponadczasowej elegancji. Drewno, jako materiał podłogowy, doskonale sprawdza się zarówno w klasycznych, jak i nowoczesnych wnętrzach, nadając im ciepły i przytulny charakter. Wybierając podłogi drewniane, inwestujesz w komfort użytkowania, wysoką jakość oraz niepowtarzalny styl.
                </p>
                <p>
                    Największą popularnością cieszą się podłogi dębowe, które wyróżniają się wyjątkową odpornością na ścieranie, stabilnością oraz pięknym, naturalnym usłojeniem. Deska podłogowa dębowa to doskonały wybór dla osób ceniących sobie trwałość i estetykę. Drewno dębowe świetnie sprawdza się w salonach, sypialniach, a także w przestrzeniach komercyjnych, zapewniając nie tylko walory wizualne, ale także komfort akustyczny i termiczny.
                </p>
                <p>
                    Odpowiednio pielęgnowane podłogi drewniane mogą służyć przez wiele lat, zachowując swój wyjątkowy wygląd. Dzięki szerokiej gamie wykończeń i kolorów, podłogi z drewna można idealnie dopasować do każdego stylu aranżacji wnętrza. W regionie Małopolski, a szczególnie w Krakowie, podłogi drewniane są wyborem numer jeden wśród osób poszukujących trwałych i estetycznych rozwiązań do swojego domu lub biura.
                </p>
                <div className="row mt-4">
                    <div className="col-md-6 col-sm-6 col-12">
                        <div className="p-details-img">
                            <img src={floorImg2} alt={sTitle + " - zdjęcie 1"} />
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-6 col-12">
                        <div className="p-details-img">
                            <img src={floorImg3} alt={sTitle + " - zdjęcie 2"} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="service-single-item list-widget">
                <div className="service-single-title">
                    <h3>Zalety podłóg drewnianych</h3>
                </div>
                <ul>
                    <li>Naturalny, niepowtarzalny wygląd i ciepło w każdym wnętrzu</li>
                    <li>Wysoka trwałość i odporność na uszkodzenia mechaniczne</li>
                    <li>Możliwość wielokrotnej renowacji i cyklinowania</li>
                    <li>Poprawa akustyki i izolacji termicznej pomieszczeń</li>
                    <li>Ekologiczne i zdrowe rozwiązanie dla domu</li>
                </ul>
            </div>
            <div className="service-single-item">
                <div className="service-single-title">
                    <h3>Dlaczego warto wybrać podłogi drewniane?</h3>
                </div>
                <p>
                    Podłogi drewniane to inwestycja na lata. Dzięki swojej uniwersalności i ponadczasowemu charakterowi, drewno nigdy nie wychodzi z mody. Jest przyjazne dla alergików, łatwe w utrzymaniu czystości i doskonale komponuje się z różnymi stylami wnętrzarskimi. Wybierając podłogi drewniane, podkreślasz prestiż i wyjątkowość swojego domu lub biura.
                </p>
            </div>
            <div className="service-single-item list-widget">
                <div className="service-single-title">
                    <h3>Proces realizacji podłóg drewnianych</h3>
                </div>
                <ul>
                    <li>Doradztwo w wyborze odpowiedniego gatunku drewna i wykończenia</li>
                    <li>Profesjonalny pomiar i przygotowanie podłoża</li>
                    <li>Montaż podłogi przez doświadczonych fachowców</li>
                    <li>Wykończenie i zabezpieczenie powierzchni</li>
                    <li>Instruktaż dotyczący pielęgnacji i konserwacji podłogi</li>
                </ul>
            </div>
        </div>
    );
};

export default FloorsServiceContent;